var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscounts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "241px",
    viewBox: "0 0 107 241",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discounts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 107,
    height: 241,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 107,
    height: 241
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.9%",
    y: "-9.8%",
    width: "145.8%",
    height: "120.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.607843137   0 0 0 0 0.607843137   0 0 0 0 0.607843137  0 0 0 0.45 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.607843137   0 0 0 0 0.607843137   0 0 0 0 0.607843137  0 0 0 0.45 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discounts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Update-regulars"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Container-Copy-2",
    fill: "#E9DCFE",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7FA6FA",
    cx: 93.5,
    cy: 93.5,
    r: 93.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Percentage-2",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(29.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.92,73.92 C75.6,73.92 73.92,75.2 73.92,78.44 C73.8065892,79.5682799 74.1773967,80.691675 74.9401844,81.5307415 C75.7029721,82.3698079 76.7860489,82.8456855 77.92,82.8400504 C79.0539511,82.8456855 80.1370279,82.3698079 80.8998156,81.5307415 C81.6626033,80.691675 82.0334108,79.5682799 81.92,78.44 C82.0705129,77.2923573 81.7165183,76.1357833 80.9494432,75.2689884 C80.182368,74.4021934 79.0774287,73.9101722 77.92,73.92 L77.92,73.92 Z",
    id: "Path",
    fill: "#5F1486",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52,58.68 L120.76,54 C118.531601,51.8546486 117.669933,48.6541691 118.52,45.68 L120.32,39.24 C120.928496,37.0537821 120.630968,34.71463 119.494549,32.7503568 C118.35813,30.7860835 116.478578,29.3622017 114.28,28.8 L108,27.12 C104.99415,26.3529797 102.64702,24.0058499 101.88,21 L100,14.52 C99.4384963,12.3123665 98.0084716,10.4254397 96.0348664,9.28798018 C94.0612611,8.15052066 91.7116759,7.85912278 89.52,8.48 L83.08,10.28 C80.1058309,11.1300667 76.9053514,10.2683991 74.76,8.04 L70.12,3.28 C68.5346625,1.67751319 66.3741648,0.775789754 64.12,0.775789754 C61.8658352,0.775789754 59.7053375,1.67751319 58.12,3.28 L53.36,8.04 C51.2146486,10.2683991 48.0141691,11.1300667 45.04,10.28 L38.6,8.48 C36.3921547,7.82150899 34.011082,8.09422392 32.009299,9.2348625 C30.0075161,10.3755011 28.5590461,12.284903 28,14.52 L26.44,21 C25.6877313,23.9999013 23.354904,26.3480762 20.36,27.12 L13.88,28.8 C11.7109391,29.3970367 9.87000644,30.835347 8.76598225,32.7955532 C7.66195807,34.7557594 7.38622148,37.075617 8,39.24 L9.8,45.68 C10.6228681,48.6543208 9.7649532,51.8408619 7.56,54 L2.6,58.68 C1.00740573,60.2706111 0.112528682,62.4291334 0.112528682,64.68 C0.112528682,66.9308666 1.00740573,69.0893889 2.6,70.68 L7.4,75.36 C9.6049532,77.5191381 10.4628681,80.7056792 9.64,83.68 L8,90.2 C7.33668405,92.3858968 7.58774035,94.7473131 8.69582555,96.7448817 C9.80391075,98.7424502 11.6743791,100.205551 13.88,100.8 L20.36,102.48 C23.3534542,103.22924 25.6907601,105.566546 26.44,108.56 L28,114.92 C28.5944488,117.125621 30.0575498,118.996089 32.0551183,120.104174 C34.0526869,121.21226 36.4141032,121.463316 38.6,120.8 L45.04,119 C48.0143208,118.177132 51.2008619,119.035047 53.36,121.24 L58.04,126.04 C59.6306111,127.632594 61.7891334,128.527471 64.04,128.527471 C66.2908666,128.527471 68.4493889,127.632594 70.04,126.04 L74.72,121.24 C76.8791381,119.035047 80.0656792,118.177132 83.04,119 L89.48,120.8 C91.6552083,121.438392 93.995784,121.174899 95.9746115,120.068863 C97.9534391,118.962826 99.4041381,117.107241 100,114.92 L101.64,108.44 C102.452373,105.381186 104.907733,103.033925 108,102.36 L114.28,100.8 C116.487633,100.238496 118.37456,98.8084716 119.51202,96.8348664 C120.649479,94.8612611 120.940877,92.5116759 120.32,90.32 L118.52,83.88 C117.669933,80.9058309 118.531601,77.7053514 120.76,75.56 L125.52,70.88 C127.185166,69.2877258 128.127025,67.0839348 128.127025,64.78 C128.127025,62.4760652 127.185166,60.2722742 125.52,58.68 Z M37.2,53.04 C37.1241396,49.6648915 38.47348,46.4139467 40.9170549,44.0845576 C43.3606298,41.7551684 46.6723803,40.5628303 50.04,40.8 C56.667417,40.8 62.04,46.172583 62.04,52.8 C62.04,59.427417 56.667417,64.8 50.04,64.8 C46.7558515,65.0309645 43.5210498,63.9024811 41.093205,61.6788476 C38.6653602,59.4552141 37.2577337,56.3317538 37.2,53.04 Z M52.2,89.6 L45.2,89.6 L75.88,41.6 L82.96,41.6 L52.2,89.6 Z M77.92,90.48 C73.5970863,90.48 69.6025492,88.1737532 67.4410923,84.4300001 C65.2796354,80.686247 65.2796354,76.073753 67.4410923,72.3299999 C69.6025492,68.5862468 73.5970863,66.28 77.92,66.28 C82.2429137,66.28 86.2374508,68.5862468 88.3989077,72.3299999 C90.5603646,76.073753 90.5603646,80.686247 88.3989077,84.4300001 C86.2374508,88.1737532 82.2429137,90.48 77.92,90.48 Z",
    id: "Shape",
    fill: "#5F1486",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,53.04 C54.3632238,51.8860066 54.0150193,50.7182144 53.2464579,49.8420545 C52.4778965,48.9658945 51.3654231,48.4685138 50.2,48.48 C47.96,48.48 46.2,49.8 46.2,53.04 C46.0986238,54.1617279 46.4748572,55.2742155 47.2362702,56.1041557 C47.9976833,56.9340959 49.0737098,57.4045716 50.2,57.400033 C51.3262902,57.4045716 52.4023167,56.9340959 53.1637298,56.1041557 C53.9251428,55.2742155 54.3013762,54.1617279 54.2,53.04 Z",
    id: "Path",
    fill: "#5F1486",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#3B2A4C",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscounts);
export default __webpack_public_path__ + "static/media/Discounts.61037c9c6f66cfcbcb3fb77b1927f719.svg";
export { ForwardRef as ReactComponent };